import { IBiLink } from '@suvo-bi-lib';

export const CATALOG_CONTENT_NAV_LINKS: IBiLink[] = [
  {
    route: 'data-sources/content',
    displayName: 'Content',
    displayIcon: 'article',
  },
  {
    route: 'data-sources/media-library',
    displayName: 'Media Library',
    displayIcon: 'photo_library',
  },
];
